export default __webpack_public_path__ + "static/media/bhavin.aa0015ae.jpg";